<script context="module">
    export const ProgressBarItemStatus = {
        PENDING: 0,
        ACTIVE: 1,
        COMPLETED: 2,
    };

    export function getStatusByStep(currentStep, stepIndex) {
        if (currentStep == 1.5 && stepIndex == 1)
            return ProgressBarItemStatus.ACTIVE;
        if (currentStep > stepIndex) return ProgressBarItemStatus.COMPLETED;
        if (currentStep == stepIndex) return ProgressBarItemStatus.ACTIVE;
        return ProgressBarItemStatus.PENDING;
    }
</script>
